<template>
  <div class="w-100pct h-100-pct bg-wt">
    <div class="bg-p1 vert h-100-pct just-space-between wid-dyn al-it-c mx-auto">
      <div class="bg-p1 p-16">
        <div class="horiz al-it-c">
          <img class="m2-r m-r-8 h1-5r m3-r h-2-rem" svg-inline src="@/assets/calc-ai-flat.svg"/>
          <span class="f1 c-c2"> Investment Goal Calculator </span>
        </div>
        <p class="al-l f0-7">
          This calculator is for illustrative purposes only and accuracy is not guaranteed.
        </p>
        <p class="al-l f0-7">
          The results are hypothetical and may not represent real performance.
        </p>
        <p class="al-l f0-7">
          Past performance is not a guarantee of future results.
        </p>
        <p class="al-l f0-7">
          Please consult with a qualified professional before investing.
        </p>
        <div class="disp-ilb shadow1 bg-wt-h p-8 r1 cursor-default" @click="$router.push({ name: 'payment' })">
          I Accept these terms
        </div>
      </div>

      <div class="h-25-vh">
        <clientsAIAd />
      </div>
    </div>
  </div>
</template>

<script>

import clientsAIAd from '../components/ClientsAIAd.vue'

export default {
  components: {
    clientsAIAd,
  },
  methods: {
    open_clients() {
      window.open("https://clients-ai.com")
    },
  }
}

</script>
